/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForProActiveScannerDetailsParserOnDemand extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForProActiveScannerDetailsParserOnDemand");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForProActiveScannerDetailsParserOnDemand.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForProActiveScannerDetailsParserOnDemand>): BackgroundJobPayloadForProActiveScannerDetailsParserOnDemand {
        let obj = Object.assign(new BackgroundJobPayloadForProActiveScannerDetailsParserOnDemand(), model);
        BackgroundJobPayloadForProActiveScannerDetailsParserOnDemand.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForProActiveScannerDetailsParserOnDemand>): BackgroundJobPayloadForProActiveScannerDetailsParserOnDemand {
        if (!model) return null;
        return BackgroundJobPayloadForProActiveScannerDetailsParserOnDemand.newInstance(<BackgroundJobPayloadForProActiveScannerDetailsParserOnDemand> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForProActiveScannerDetailsParserOnDemand) {
        if (!obj) return;

        models.BackgroundJobPayloadForProActiveScannerDetailsParserOnDemand.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForProActiveScannerDetailsParserOnDemand): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForProActiveScannerDetailsParserOnDemand.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service Account ID that needs to processed
     */
    service_account_id: string;

    /**
     * Github Repository Id that needs to be be processed
     */
    repository_id: string;

    /**
     * Github Pull Request Number that needs to be processed
     */
    pull_request_number: string;

}
